import { renderForCriticalMoment } from '../dashHelper';
import { getCommonWidget } from '../dashWidgetHelper'
import { commonWidgets } from "./commonWidgetsCaffenio";
export const renderForGeoLocation = (filters: FiltersUI, geoIncludes: number[]) => {
    return (
        filters !== undefined &&
        filters.geographicDistributions !== undefined &&
        filters.geographicDistributions !== null &&
        filters.geographicDistributions.length == 1 &&
        filters.geographicDistributions.some(geo => geoIncludes.includes(geo))
    )
}

export default {
    title: 'Apertura Dashboard',
    description: 'Apertura Default',
    widgets: (filters: FiltersUI) => [
        // ---------------------------------------------------------
        // INDICADORES PRINCIPALES
        // ---------------------------------------------------------
        { title: 'INDICADORES PRINCIPALES', type: 'label', position: [0, 0], size: [4, 1], config: { id: 'indicadores-principales-label', type: 'label', color: '#B7AADC' } },

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'gaugeGeneric',
            title: "Satisfacción del establecimiento",
            position: [0, 0],
            size: [1, 2],
            indicator: "apertura_pregunta_1",
            criticalMomentInclude: [10252],
            extraConfigs: {
                id: "apertura_pregunta_1_gauge",
                decimals: 1,
                maxValue: 10,
                colors: '#3e9d8e',
                lineWidth: 15,
                radius: '85%',
                labelFontSize: 40,
                labelColor: '#2B143C',
                valueMultiplier: 0.1,
                gaugeTitle: 'promedio / 10'
            },
            extraIndicatorConfigs: {
                extras: { formula: 'count-number' }
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'gaugeGeneric',
            title: "NPS de apertura",
            position: [1, 0],
            size: [1, 2],
            indicator: "apertura_pregunta_5",
            criticalMomentInclude: [10252],
            extraConfigs: {
                id: "apertura_pregunta_5_gauge",
                decimals: 0,
                maxValue: 100,
                colors: '#c383e1',
                lineWidth: 18,
                radius: '85%',
                labelFontSize: 50,
                labelColor: '#2B143C',
                gaugeTitle: 'NPS'
            },
            extraIndicatorConfigs: {
                extras: { formula: 'nps-10' }
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'gaugeGeneric',
            title: "Intención de recompra",
            position: [3, 0],
            size: [1, 2],
            indicator: "apertura_pregunta_4",
            criticalMomentInclude: [10252],
            extraConfigs: {
                id: "apertura_pregunta_4_gauge",
                decimals: 1,
                maxValue: 10,
                colors: '#9ad37a',
                lineWidth: 15,
                radius: '85%',
                labelFontSize: 40,
                labelColor: '#2B143C',
                valueMultiplier: 0.1,
                gaugeTitle: 'promedio / 10'
            },
            extraIndicatorConfigs: {
                extras: { formula: 'count-number' }
            }
        }),


        // ---------------------------------------------------------
        // SATISFACCIÓN
        // ---------------------------------------------------------

        { title: 'SATISFACCIÓN', type: 'label', position: [0, 0], size: [4, 1], config: { id: 'indicadores-principales-label', type: 'label', color: '#B7AADC' } },

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Atributos de satisfacción',
            position: [0, 2],
            size: [2, 3],
            indicator: 'apertura_pregunta_89',
            criticalMomentInclude: [10252],
            extraConfigs: {
                center: ['50%', '50%'],
                radius: ['40%', '70%'],
                arcLabelsRadiusOffset: 1.15,
                showLegend: true,
                legendTop: 'bottom'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Lo más valorado del servicio',
            position: [2, 2],
            size: [2, 3],
            indicator: 'apertura_pregunta_69',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),

        // ---------------------------------------------------------
        // ORIGEN DEL CONSUMO Y COMPETENCIA
        // ---------------------------------------------------------
        { title: 'ORIGEN DEL CONSUMO Y COMPETENCIA', type: 'label', position: [0, 0], size: [4, 1], config: { id: 'indicadores-principales-label', type: 'label', color: '#B7AADC' } },

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Origen del consumo previo',
            position: [0, 5],
            size: [2, 3],
            indicator: 'apertura_pregunta_9',
            criticalMomentInclude: [10252],
            extraConfigs: {
                center: ['50%', '50%'],
                radius: ['40%', '70%'],
                arcLabelsRadiusOffset: 1.15,
                showLegend: true,
                legendTop: 'bottom'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Tienda de conveniencia previa',
            position: [2, 5],
            size: [2, 3],
            indicator: 'apertura_pregunta_12',
            criticalMomentInclude: [10252],
            extraConfigs: {
                center: ['35%', '50%'],
                radius: ['45%', '65%'],
                showLegend: true,
                legendTop: 'middle',
                legendLeft: 'right',
                legendOrient: 'vertical'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByTag',
            title: 'Cafetería previa',
            position: [0, 8],
            size: [2, 3],
            indicator: 'apertura_pregunta_10',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Café que consumía en casa u oficina',
            position: [2, 8],
            size: [2, 3],
            indicator: 'apertura_pregunta_11',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),

        // ---------------------------------------------------------
        // HÁBITOS DE VISITA
        // ---------------------------------------------------------
        { title: 'HÁBITOS DE VISITA', type: 'label', position: [0, 0], size: [4, 1], config: { id: 'indicadores-principales-label', type: 'label', color: '#B7AADC' } },

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Momento del día de la visita',
            position: [0, 11],
            size: [2, 2],
            indicator: 'apertura_pregunta_18',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Antigüedad como cliente',
            position: [2, 11],
            size: [2, 2],
            indicator: 'apertura_pregunta_15',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Cambio de ruta habitual',
            position: [0, 14],
            size: [2, 2],
            indicator: 'apertura_pregunta_91',
            criticalMomentInclude: [10252],
            extraConfigs: {
                center: ['35%', '50%'],
                radius: ['45%', '65%'],
                showLegend: true,
                legendTop: 'middle',
                legendLeft: 'right',
                legendOrient: 'vertical'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Tiempo de traslado a la sucursal',
            position: [2, 14],
            size: [2, 2],
            indicator: 'apertura_pregunta_19',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Destino después de la compra',
            position: [0, 17],
            size: [2, 2],
            indicator: 'apertura_pregunta_20',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),

        // ---------------------------------------------------------
        // EXPERIENCIA DRIVE
        // ---------------------------------------------------------
        { title: 'EXPERIENCIA DRIVE', type: 'label', position: [0, 0], size: [4, 1], config: { id: 'indicadores-principales-label', type: 'label', color: '#B7AADC' } },


        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'gaugeGeneric',
            title: "Uso del servicio Drive",
            position: [0, 20],
            size: [1, 2],
            indicator: "apertura_pregunta_24",
            criticalMomentInclude: [10252],
            extraConfigs: {
                id: "apertura_pregunta_24_gauge",
                decimals: 0,
                maxValue: 100,
                colors: '#3e9d8e',
                showPercentage: true,
                radius: '85%',
                lineWidth: 15,
                labelFontSize: 40,
                labelColor: '#2B143C',
                gaugeTitle: 'si lo utilizó'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'gaugeGeneric',
            title: "Amabilidad del operador",
            position: [1, 20],
            size: [1, 2],
            indicator: "apertura_pregunta_29",
            criticalMomentInclude: [10252],
            extraConfigs: {
                id: "apertura_pregunta_29_gauge",
                decimals: 0,
                maxValue: 100,
                colors: '#9ad37a',
                showPercentage: true,
                radius: '85%',
                lineWidth: 15,
                labelFontSize: 40,
                labelColor: '#2B143C',
                gaugeTitle: 'saludo, sonrisa y despedida'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'gaugeGeneric',
            title: "Volvería con tiempo similar",
            position: [2, 20],
            size: [1, 2],
            indicator: "apertura_pregunta_64",
            criticalMomentInclude: [10252],
            extraConfigs: {
                id: "apertura_pregunta_64_gauge",
                decimals: 0,
                maxValue: 100,
                colors: '#c383e1',
                showPercentage: true,
                radius: '85%',
                lineWidth: 15,
                labelFontSize: 40,
                labelColor: '#2B143C',
                gaugeTitle: 'volvería'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'gaugeGeneric',
            title: "Facilidad de la pantalla",
            position: [3, 20],
            size: [1, 2],
            indicator: "apertura_pregunta_25",
            criticalMomentInclude: [10252],
            extraConfigs: {
                id: "apertura_pregunta_25_gauge",
                decimals: 0,
                maxValue: 100,
                colors: '#d7e351',
                showPercentage: true,
                radius: '85%',
                lineWidth: 15,
                labelFontSize: 40,
                labelColor: '#2B143C',
                gaugeTitle: '"muy fácil"'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Tiempo del pedido',
            position: [0, 22],
            size: [2, 3],
            indicator: 'apertura_pregunta_98',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Percepción del tiempo',
            position: [2, 22],
            size: [2, 3],
            indicator: 'apertura_pregunta_99',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Tiempo considerado razonable',
            position: [0, 25],
            size: [2, 3],
            indicator: 'apertura_pregunta_78',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),

        // ---------------------------------------------------------
        // PRODUCTO Y DEMOGRAFÍA
        // ---------------------------------------------------------
        { title: 'PRODUCTO Y DEMOGRAFÍA', type: 'label', position: [0, 0], size: [4, 1], config: { id: 'indicadores-principales-label', type: 'label', color: '#B7AADC' } },

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Disponibilidad del producto',
            position: [0, 28],
            size: [2, 3],
            indicator: 'apertura_pregunta_30',
            criticalMomentInclude: [10252],
            extraConfigs: {
                center: ['35%', '50%'],
                radius: ['45%', '65%'],
                showLegend: true,
                legendTop: 'middle',
                legendLeft: 'right',
                legendOrient: 'vertical'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Lo que les gustaría encontrar en el menú',
            position: [2, 28],
            size: [2, 3],
            indicator: 'apertura_pregunta_59',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Género',
            position: [0, 31],
            size: [2, 3],
            indicator: 'apertura_pregunta_33',
            criticalMomentInclude: [10252],
            extraConfigs: {
                center: ['35%', '50%'],
                radius: ['45%', '65%'],
                showLegend: true,
                legendTop: 'middle',
                legendLeft: 'right',
                legendOrient: 'vertical'
            }
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'barByQuestion',
            title: 'Rango de edad',
            position: [2, 31],
            size: [2, 3],
            indicator: 'apertura_pregunta_34',
            criticalMomentInclude: [10252],
            extraConfigs: {
                percentageScale: true,
                showValues: true,
                showLegend: false,
                interval: 0,
                wrapTexts: true
            },
            extraIndicatorConfigs: {
                label: 'group',
                grouped: undefined
            }
        }),

        // ---------------------------------------------------------
        // ANÁLISIS DE SENTIMIENTOS
        // ---------------------------------------------------------
        { title: 'ANÁLISIS DE SENTIMIENTOS', type: 'label', position: [0, 0], size: [4, 1], config: { id: 'indicadores-principales-label', type: 'label', color: '#B7AADC' } },

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'textAnalysis',
            title: 'Análisis de Sentimientos',
            position: [0, 34],
            size: [4, 4],
            indicator: "SENTIMENT",
            criticalMomentId: 10252
        })
    ]
}
